import { useState } from 'react';
import PropTypes from 'prop-types';

import JuristecLogoNew from '../../../juristec-ui/icons/JuristecLogoNew';
import Tooltip from '../../../juristec-ui/core/Tooltip';
import IconButton from '../../../juristec-ui/core/IconButton';
import Popover from '../../../juristec-ui/core/Popover';
import List from '../../../juristec-ui/core/List';
import ListItem from '../../../juristec-ui/core/ListItem';

import { formatDateTime } from '../../../juristec-ui/utils/functions/lab';

import {
  Container,
  DashboardName,
  OwnerInformation,
  InfoContainer,
  DevelopmentCredits,
  RightSide,
  BtnsContainer,
} from './styled/PublicKpiToolbar.styled';

import { Markers, Width } from '../../../juristec-ui/icons';

const DefaultProps = {
  dashboardDoc: {},
  markers: [],
};

const PublicKpiToolbar = ({
  dashboardDoc = DefaultProps.dashboardDoc,
  markers = DefaultProps.markers,
  handleSize,
}) => {
  const [openPopoverMarkers, setOpenPopoverMarkers] = useState(false);

  const toggleMarkesPopover = () => setOpenPopoverMarkers((o) => !o);
  const closeMarkersPopover = () => setOpenPopoverMarkers(false);

  const goToMarker = (key) => {
    document.getElementById(key).scrollIntoView(
      { block: 'start', behavior: 'smooth', inline: 'center' },
    );
  };

  return (
    <Container>
      <InfoContainer>
        <OwnerInformation>
          {/* <div>
            <span className="info-title">Criado por:</span>
            <span className="info-description">
              {' '}
              {dashboardDoc?.displayName}
            </span>
          </div> */}
          {dashboardDoc?.generatedAt && (
            <div>
              <span className="info-title">Gerado em:</span>
              <span className="info-description">
                {' '}
                {formatDateTime(dashboardDoc?.generatedAt, { time: 'half' })}
              </span>
            </div>
          )}
          {/* {dashboardDoc?.expiresAt && (
            <div>
              <span className="info-title">Expira em:</span>
              <span className="info-description">
                {' '}
                {dashboardDoc.expiresAt !== 'NEVER'
                  ? formatDateTime(dashboardDoc?.expiresAt, { time: 'half' })
                  : 'Não expira' }
              </span>
            </div>
          )} */}
        </OwnerInformation>
        <DashboardName>
          {dashboardDoc?.name || ''}
        </DashboardName>
        <RightSide>
          <DevelopmentCredits>
            {process.env.REACT_APP_FIREBASE_PROJECT_LABEL !== 'benner-metrics' && (
              <>
                <span className="footer-text">
                  Desenvolvido por Juristec
                </span>
                <JuristecLogoNew />
              </>
            )}
          </DevelopmentCredits>
          <BtnsContainer>
            <Tooltip text="Largura do grid">
              <IconButton
                onClick={handleSize}
                size="medium"
                shape="rounded"
              >
                <Width />
              </IconButton>
            </Tooltip>
            {markers.length > 0 && (
              <div>
                <Popover
                  open={openPopoverMarkers}
                  closePopover={closeMarkersPopover}
                >
                  <Popover.Action>
                    <Tooltip text="Marcadores">
                      <IconButton
                        onClick={toggleMarkesPopover}
                        size="medium"
                        shape="rounded"
                      >
                        <Markers />
                      </IconButton>
                    </Tooltip>
                  </Popover.Action>
                  <Popover.Content direction="bottom-end" offset={[-10, 0]}>
                    <List style={{ maxHeight: 300, overflow: 'auto' }}>
                      {markers.map((m) => (
                        <ListItem
                          key={m.key}
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'flex-start',
                            maxWidth: '250px',
                            margin: 'auto',
                          }}
                          onClick={() => goToMarker(m.key)}
                        >
                          <span
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              margin: 'auto',
                            }}
                          >
                            {m.name}
                          </span>
                        </ListItem>
                      ))}
                    </List>
                  </Popover.Content>
                </Popover>
              </div>
            )}
          </BtnsContainer>
        </RightSide>
      </InfoContainer>
    </Container>
  );
};

PublicKpiToolbar.propTypes = {
  dashboardDoc: PropTypes.shape({
    name: PropTypes.string,
    displayName: PropTypes.string,
    generatedAt: PropTypes.string,
    expiresAt: PropTypes.string,
  }),
  markers: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
  })),
  handleSize: PropTypes.func.isRequired,
};

export default PublicKpiToolbar;
